// extracted by mini-css-extract-plugin
export default {"create-account-button":"VWWCCnqzJqTLuABKFvdA","expired-invite":"A5x_GVivgrrA9VgqTooD"};